export default __webpack_public_path__ + "img/cbEwLGlW.ee49f82e.svg";